// A short/empty page is valid when its cursor still advances.
export const isPaginationStalled = (cursor, { hasNextPage, endCursor } = {}) =>
  !!hasNextPage &&
  (endCursor === undefined ||
    endCursor === null ||
    endCursor === '' ||
    String(endCursor) === String(cursor))
